export default "__VITE_ASSET__DaA8T21J__"